/** Load index helpers and roster coverage aggregates. */

export function withLoadIndex(doctors = []) {
  return doctors.map((d) => {
    const hours = Number(d.hours_rostered) || 0;
    const visits = Number(d.visits) || 0;
    const loadIndex = visits / Math.max(hours, 0.5);
    return { ...d, loadIndex };
  }).sort((a, b) => b.loadIndex - a.loadIndex);
}

export function rosterCoverage(shifts = []) {
  const byDate = {};
  let published = 0;
  let draft = 0;
  shifts.forEach((s) => {
    const d = s.date || '';
    if (!byDate[d]) byDate[d] = { date: d, count: 0, published: 0 };
    byDate[d].count += 1;
    if (s.published !== false) {
      byDate[d].published += 1;
      published += 1;
    } else draft += 1;
  });
  const days = Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date));
  return { days, published, draft, coveredDays: days.filter((d) => d.published > 0).length };
}
